/**
 * Computed wrapper classes for the carousel container
 * Handles arrow padding and custom class merging
 */
export const getCarouselWrapperClasses = (props: {
  showArrows?: boolean;
  className?: string;
  arrowsPosition?: 'outside' | 'bottom' | 'left';
}): string => {
  return twMerge(
    'relative',
    cva('', {
      variants: {
        showArrows: {
          true: '',
          false: '',
        },
        arrowsPosition: {
          outside: '',
          bottom: '',
          left: '',
        },
      },
      compoundVariants: [
        {
          showArrows: true,
          arrowsPosition: 'outside',
          class: 'px-13 md:px-16',
        },
      ],
    })({
      showArrows: props.showArrows ?? false,
      arrowsPosition: props.arrowsPosition,
    }),
    props.className,
  );
};

/**
 * Computed viewport classes
 * The viewport is the overflow container
 */
export const getCarouselViewportClasses = (props: {
  viewportClassName?: string;
}): string => {
  return twMerge('mx-auto w-full overflow-hidden', props.viewportClassName);
};

/**
 * Computed container classes
 * The container holds all slides and is draggable
 */
export const getCarouselContainerClasses = (props: {
  containerClassName?: string;
}): string => {
  return twMerge(
    'flex touch-pan-y touch-pinch-zoom items-stretch',
    props.containerClassName,
  );
};

/**
 * Computed slide classes for standard carousel
 * Responsive: 100% -> 50% -> 25% width
 * If slideClassName is provided, it completely replaces the default classes
 */
export const getCarouselSlideClasses = (props: {
  slideClassName?: string;
}): string => {
  return (
    props.slideClassName
    || 'min-w-0 flex-[0_0_100%] px-4 md:flex-[0_0_50%] lg:flex-[0_0_25%]'
  );
};

/**
 * Alternative slide classes for autoplay variant
 * Uses slightly different responsive breakpoints
 * Responsive: 100% -> 100% -> 33.33% width
 * If slideClassName is provided, it completely replaces the default classes
 */
export const getCarouselSlideClassesAutoplayVariant = (props: {
  slideClassName?: string;
}): string => {
  return (
    props.slideClassName || 'min-w-0 flex-[0_0_100%] px-2 lg:flex-[0_0_33.333%]'
  );
};
